import React from 'react';
import KineticHero from './sections/KineticHero';
import HowOnePlaceWorksSection from './sections/HowOnePlaceWorksSection';
import PlatformPillarsSection from './sections/PlatformPillarsSection';
import GovernanceSection from './sections/GovernanceSection';
import IntegrationsSection from './sections/IntegrationsSection';
import DeploymentSection from './sections/DeploymentSection';
import FinalCTASection from './sections/FinalCTASection';
import Header from './Header';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <Header />
      <KineticHero />
      <div className="section-divider" />
      <HowOnePlaceWorksSection />
      <div className="section-divider" />
      <PlatformPillarsSection />
      <IntegrationsSection />
      <div className="section-divider" />
      <GovernanceSection />
      <div className="section-divider" />
      <DeploymentSection />
      <div className="section-divider" />
      <FinalCTASection />
      <Footer />
    </div>
  );
};

export default LandingPage;